import { render } from "./EventPayouts.vue?vue&type=template&id=64fd0579&scoped=true&ts=true&lang=pug"
import script from "./EventPayouts.vue?vue&type=script&lang=ts"
export * from "./EventPayouts.vue?vue&type=script&lang=ts"

import "./EventPayouts.vue?vue&type=style&index=0&id=64fd0579&scoped=true&lang=css"

import exportComponent from "/var/lib/gitlab-runner/builds/Ysdfp3TDT/0/z2a/z-tracker-partners/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64fd0579"]])

export default __exports__